"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xhrOptionsDefault = void 0;
const types_1 = require("./types");
exports.xhrOptionsDefault = {
    headers: {
        'Accept': 'application/json',
        'Content-Type': types_1.MediaType.JSON,
    },
    plugins: [],
    responseType: types_1.MediaType.JSON,
};
//# sourceMappingURL=options.js.map